module.exports = __webpack_public_path__ + "img/background_general.62e40eb3.jpg";